import PropTypes from 'prop-types';
import React from 'react';

import Box              from '@mui/material/Box';
import Typography       from '@mui/material/Typography';
import grey             from '@mui/material/colors/grey';

import { Iterable, List } from 'immutable';

// 
// { identifier, name, logo, value, onChange }
function Channel({ ...props }) {
  const CHANNEL_CONTAINER_STYLE = {
    border:         1,
    borderRadius:   2,
    alignItems:     'center',
    borderColor:    grey[500],
    justifyContent: 'center',
    display:        'flex',
    p:              1,
    m:              1,
  };

  const MAIN_CONTAINER_STYLE = {
    display:        'flex',
    flexDirection:  'column',
    justifyContent: 'center',
    alignItems:     'center',
  };

  const TEXT_STYLE = {
    fontSize: '10px',
  };

  const CHECKED_CHANNEL_STYLE = {
    backgroundColor: 'primary.main',
    color:           'white',
    border:          1,
    borderColor:     'black',
  };

  const channelContainerStyle = () => {
    if (props.checked && props.checked.includes(props.identifier)) {
      return { ...CHANNEL_CONTAINER_STYLE, ...CHECKED_CHANNEL_STYLE };
    }
    return CHANNEL_CONTAINER_STYLE;
  };

  return (
    <Box sx={MAIN_CONTAINER_STYLE} onClick={() => props.onChange(props.identifier)} data-testid="channel_container">
      <Box sx={channelContainerStyle()} data-testid={`channel_${props.identifier}`}>
        {props.icon}
      </Box>
      <Typography variant="small" sx={TEXT_STYLE}>{props.name}</Typography>
    </Box>
  );
}

Channel.propTypes = {
  name:       PropTypes.string,
  icon:       PropTypes.element,
  identifier: PropTypes.string,
  checked:    PropTypes.objectOf(Iterable),
  onChange:   PropTypes.func,
};

export default Channel;
